import { types } from './importerActions';

const initialState = {
    pending: false,
    payload: {},
    isLoad: false,
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.HTTP_PENDING_IMPORTER:
            return {
                ...state,
                pending: true,
                isLoad:false
            }
        case types.HTTP_SUCCESS_IMPORTER:
            return {
                ...state,
                pending: false,
                payload: action.payload,
                isLoad:true
            }

        case types.HTTP_ERROR_IMPORTER:
            return {
                ...state,
                pending: false,
                error: action.error,
            }
        default:
            return state;
    }
}

